<div class="json-properties-panel">

    <!-- JSON PLAYER WIZARD -->
    <div *ngIf="inDev" class="properties-section">
        <div class="section-content">
            <div class="json-wizard-button-container">
                <button mat-raised-button color="warn" (click)="openJsonPlayerWizard()" class="json-wizard-button">
                    <mat-icon>auto_awesome</mat-icon>
                    {{ 'ai.customFeed' | transloco }}
                </button>
            </div>
        </div>
    </div>

    <!-- TOKENIZED CONNECTION -->
    @if (tokenized) {
        <div class="properties-section">
            <div class="section-header">
                <mat-icon class="section-icon">power</mat-icon>
                <span class="section-title">account connection</span>
            </div>

            <div class="section-content">
                <button class="connect-button" mat-raised-button color="warn" (click)="onCreateToken()" matTooltip="{{'general.createToken' | transloco}}">
                    <mat-icon>power</mat-icon>
                    {{ 'general.connectToAccount2' | transloco }}
                </button>
            </div>
        </div>
    }

    <!-- SOCIAL TOKEN -->
    @if (socialized) {
        <div class="properties-section fade-in">
            <div class="section-header">
                <mat-icon class="section-icon">share</mat-icon>
                <span class="section-title">social token</span>
            </div>

            <div class="section-content">
                <app-scene-social-token></app-scene-social-token>
            </div>
        </div>
    }

    <!-- PLAYER TYPE SPECIFIC CONTENT -->
    <div>
        @switch (this.sceneItem?.$?.player) {
            @case (blockLabelRecords?.STOCKS.id) {
                <div class="properties-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">candlestick_chart</mat-icon>
                        <span class="section-title">stock symbols</span>
                    </div>

                    <div class="section-content">
                        <button (click)="appendDefaultStocks()" mat-raised-button color="primary">
                            <mat-icon>refresh</mat-icon>
                            {{ 'general.resetStocksSymbols' | transloco }}
                        </button>

                        <div class="stock-info">
                            {{ 'general.totalStockSymbols' | transloco }}: <strong>{{ totalStockSymbols }}</strong>
                        </div>
                    </div>
                </div>
            }
            @case (blockLabelRecords?.CATALOG.id) {
                <div class="properties-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">category</mat-icon>
                        <span class="section-title">catalog categories</span>
                    </div>

                    <div class="section-content">
                        <app-category-tree
                            [createMode]="false"
                            [expandAll]="true"
                            [setCategoryValues]="categoryTreeItems"
                            (updateTreeSelection)="onUpdateTreeSelection($event)">
                        </app-category-tree>
                    </div>
                </div>
            }
        }
    </div>

    <!-- SCENE SELECTOR -->
    <div class="properties-section">
        <div class="section-header">
            <mat-icon class="section-icon">dashboard</mat-icon>
            <span class="section-title">scene assignment</span>
        </div>

        <div class="section-content">
            <div class="scene-selector-group">
                <mat-form-field class="scene-select-field">
                    <mat-label>{{ 'general.selectScene' | transloco }}</mat-label>
                    <mat-select [(value)]="assignedScene" (selectionChange)="onSceneChange($event)" panelClass="scene-select-panel-wide">
                        @for (scene of this.scenesSimple; track scene) {
                            <mat-option [value]="scene">
                                {{ scene.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="scene-actions">
                    <button mat-icon-button (click)="openSceneAssignmentDialog()" matTooltip="{{'general.importScene' | transloco}}">
                        <mat-icon>star</mat-icon>
                    </button>
                    <button mat-icon-button (click)="openSceneEditor()" matTooltip="{{'general.jumpToScene' | transloco}}">
                        <mat-icon>link</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- DYNAMIC PROPERTIES -->
    @if (dynamicsInitialized) {
        <div class="properties-section">
            <div class="section-header">
                <mat-icon class="section-icon">settings</mat-icon>
                <span class="section-title">data properties</span>
            </div>

            <div class="section-content">
                <dynamic-form #dynamicFormComponent
                    [fields]="uiConfigInit"
                    (submit)="submit($event)">
                </dynamic-form>
            </div>
        </div>
    }

    <!-- TOKEN BINDING -->
    @if (tokenized) {
        <div class="properties-section">
            <div class="section-header">
                <mat-icon class="section-icon">vpn_key</mat-icon>
                <span class="section-title">token binding</span>
            </div>

            <div class="section-content">
                <div class="token-selector-group">
                    <mat-form-field class="token-field">
                        <mat-label>{{ tokenFieldName }}</mat-label>
                        <input inputrestriction="basic1" matInput placeholder="" [value]="selectedTokenValue.id" readonly>
                    </mat-form-field>

                    <button mat-icon-button (click)="showTokenListTreeview()" matTooltip="{{'general.refresh' | transloco}}">
                        <mat-icon>folder_open</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    }

    <!-- CATALOG ITEM FONT SELECTOR -->
    @switch (this.sceneItem?.$?.player) {
        @case (blockLabelRecords?.CATALOG_ITEM?.id) {
            <div class="properties-section">
                <div class="section-header">
                    <mat-icon class="section-icon">font_download</mat-icon>
                    <span class="section-title">font settings</span>
                </div>

                <div class="section-content">
                    <app-font-selector (onChange)="onFontChanged($event, '', 'CATALOG_ITEM')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
                </div>
            </div>
        }
    }
</div>



